import { render, staticRenderFns } from "./DeleteFactcheckDialog.vue?vue&type=template&id=529a87c5"
import script from "./DeleteFactcheckDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteFactcheckDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports